import React from 'react';
import { UserLayout } from 'ui/components/layouts';
import { Container, Title } from 'ui/components/styled';
import Text from 'ui/components/styled/Text';
import { version } from '../../../../../../package.json';

export function About() {
  return (
    <UserLayout>
      <Title variant="dark" mx="m" mb="xxl">
        About
      </Title>
      <Container mx="m" maxWidth="90%" alignItems="center">
        <Text>
          <strong>Version: {version}</strong>
        </Text>
        <Text my="m" lineHeight="1.7">
          © Copyright 2022, Process Watch Technologies, LLC. All Rights Reserved.
        </Text>
      </Container>
    </UserLayout>
  );
}
